module.exports = __webpack_public_path__ + "static/media/folha2.5d3b0a75.png";